import React from 'react';
import { getImg } from '@/pages/home/_config/getImgs';
import { useIntl } from 'umi';
import { gotoIntelligenceGame, gotoDashboardGame } from '@/pages/home/utils/utils';
import { getCountryFlag } from '@/pages/home/_config/countries';

const metricCfgMap: any = {
  gsd__gsd_digitalUnits: {
    filters: [
      {
        key: 'region',
        value: (payload: any) => payload?.markets || ['global'],
      },
      {
        key: 'metrics',
        value: ['gsd::gsd_digitalUnits'],
      },
      {
        key: 'granularity',
        value: 'weekly',
      },
      // {
      //   key: 'segment',
      //   value: (payload: any) => payload?.segments || [],
      // },
    ],
  },
  mscience__digitalRevenue: {
    filters: [
      {
        key: 'region',
        value: (payload: any) => payload?.markets || ['global'],
      },
      {
        key: 'metrics',
        value: ['mscience::digitalRevenue'],
      },
    ],
  },
  mscience__units: {
    filters: [
      {
        key: 'region',
        value: (payload: any) => payload?.markets || ['global'],
      },
      {
        key: 'metrics',
        value: ['mscience::units'],
      },
      // {
      //   key: 'segment',
      //   value: (payload: any) => payload?.segments || [],
      // },
    ],
  },
};

export default function Intelligence(props: any) {
  let { data, currentItem, isGetDashboard = false } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const getGotoTab = (name: string) => {
    // console.log('namename', name);
    switch (name) {
      case 'storeRank':
        return name;
      case 'rank':
          return 'storeRank';
      case 'hoursWatched':
      case 'peackCCV':
      case 'airtime':
        return 'streaming';
      default:
        return 'stats';
    }
  }

  // 跳转到情报游戏详情页
  const gotoIntelligenceDetail = (e: any) => {
    e.stopPropagation();
    const { game_id, entity_type } = currentItem;
    if (isGetDashboard) {
      gotoDashboardGame(currentItem.game_code);
    } else {
      const metricCfgKey = `${data?.icon}__${data?.goto}`;
      const metricCfg = metricCfgMap?.[metricCfgKey];
      if (!!metricCfg) {
        const metricFiltersKeys = metricCfg?.filters;
        const metricFilterValue = metricFiltersKeys?.reduce((acc, cur) => {
          const key = cur?.key;
          const value = cur?.value;
          const valueTmp = typeof value === 'function' ? value(data) : value;
          return { ...acc, [key]: valueTmp };
        }, {});
        gotoIntelligenceGame(game_id, entity_type, getGotoTab(data?.goto), '', '', metricFilterValue);
        return;
      }
      gotoIntelligenceGame(game_id, entity_type, getGotoTab(data.goto), data.goto === 'storeRank' ? '' : data.goto, data.goto === 'storeRank' ? '' : data.gotoOld);
    }
  }

  return (
    <div className='intelligence intelligence-pointer' onClick={(e) => { gotoIntelligenceDetail(e) }}>
      <div className='intelligence-title'>
        {
          !data.list ?
            <>
              {data.icon != '' && <img src={getImg(data.icon)} className='intelligence-icon intelligence-icon-searchinfo' />}
              {(data.marketImg != '' && currentItem?.entity_type === 'combine' && !isGetDashboard)
                && <img src={getCountryFlag(data.marketImg)} className='intelligence-icon-searchmarket' alt="flag" />}
              <span>{data.title ? formatMessage({ id: data.title }) : ''}</span>
            </> :
            <span>{data.title ? formatMessage({ id: data.title || '' }) : ''}</span>
        }
      </div>
      {
        !data.list ?
          <div className='intelligence-date'>
            <span className='intelligence-date-span'>{data.date || ' '}</span>
          </div> : null
      }
      {
        data.list ?
          <>
            <div className='intelligence-flex'>
              {data.list.map((e: any, i: any) => {
                return <>
                  <div className='intelligence-date intelligence-date-store'>
                    <span className='intelligence-date-span'>{e.date || ' '}</span>
                  </div>
                </>
              })}
            </div>
            <div className='intelligence-flex'>
              {data.list.map((e: any, i: any) => {
                return <>
                  <span key={i} className='intelligence-num intelligence-num-storerank'>
                    <img src={getImg(e.icon)} className='intelligence-img' />{e.num}
                  </span>
                </>
              })}
            </div>
          </> :
          <>
            {data.rank !== '' ? <div className='intelligence-flex'>
              <span className='intelligence-num'>{isGetDashboard ? data.num : `#${data.rank}`}</span>
            </div> :
              <div className='intelligence-flex'>
                <span className='intelligence-num'>{data.num}</span>
                <span className='intelligence-text'>{data.text}</span>
              </div>}
          </>
      }
    </div >
  );
};
